// src/app/[lang]/components/LazyVideoPlayer.tsx
"use client";

import React from 'react';
import dynamic from 'next/dynamic';

const VideoPlayer = dynamic(() => import('./VideoPlayer'), {
  loading: () => (
    <div className="w-full mt-3 bg-gray-200 animate-pulse rounded" style={{ aspectRatio: '16/9' }}>
      <div className="flex items-center justify-center h-full">
        <svg
          className="w-16 h-16 text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
        </svg>
      </div>
    </div>
  ),
  ssr: false,
});

interface LazyVideoPlayerProps {
  url: string;
  caption?: string;
}

/**
 * Lazy-loading wrapper for video player with inline loading placeholder
 */
export default function LazyVideoPlayer({ url, caption }: LazyVideoPlayerProps) {
  return (
    <div className="print:hidden mt-3">
      <VideoPlayer url={url} caption={caption} />
    </div>
  );
}
